// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"612":"ce335717c117ec112980","756":"0eff2b3e462843977e55"}[chunkId] + ".js";
};